import { Dropdown } from "react-bootstrap";
import styles from "./keyfobcard.module.css";
import { MoreVertical, Trash2 } from "react-feather";
import Tooltip from '@mui/material/Tooltip';
import { useAuth0 } from "@auth0/auth0-react";

const KeyfobDetailsCard = ({ deviceDetails, setDeleteModalOpen2 }) => {
    const { isAuthenticated, user } = useAuth0();

    return <div className={`${styles.SMProCusSmallDiv}`}>
        <div className={`${styles.CardSmall}`}>
            <div className={`${styles.SMProCardHead}`}>
                <div className={`${styles.SMProPicMain}`}>
                    <Tooltip title="Dimmer" placement="bottom">
                        <div className={`${styles.avatar} ${styles.active}`}>
                            <img src="/static/img/door-key-icon.svg" alt="" />
                        </div>
                    </Tooltip>
                </div>
                <h5>{deviceDetails?.card_name}</h5>
                <p className={`${styles.KeyFobNo}`}>{deviceDetails?.card_number}</p>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device-keyfob:delete") > -1) && <Dropdown className={`${styles.ProEditSec}`}>
                    <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen2(true)}>
                            <Trash2 /> Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>}
            </div>
        </div>
    </div>
}

export default KeyfobDetailsCard;